"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiBaseUrl = void 0;
const runtime_config_1 = require("../../config/runtime-config");
const getApiBaseUrl = () => {
    const { API_URL } = (0, runtime_config_1.getConfig)();
    return API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
};
exports.getApiBaseUrl = getApiBaseUrl;
